import React from 'react';
import { Tooltip } from 'react-tooltip';
import AdvisoriesSummaryProps from '../interfaces/AdvisoriesSummaryProps';
import AdvisoryNpm from './AdvisoryNpm';

const AdvisoriesSummaryNpm: React.FC<AdvisoriesSummaryProps> = ({ report }) => {

console.log(report);
    return <ul>
        {Object.keys(report.vulnerabilities).map((packageIdentifier: string) => (
            <li key={packageIdentifier}>
                <strong>{report.vulnerabilities[packageIdentifier].name}</strong>
                <ul>
                    <li>
                        <a href={report.vulnerabilities[packageIdentifier].via[0].url} target="_blank" rel="noreferrer" data-tooltip-id={`tooltip-${packageIdentifier}`}>{report.vulnerabilities[packageIdentifier].via[0].title}</a>
                        <Tooltip
                            id={`tooltip-${packageIdentifier}`}
                            place="bottom"
                        >
                            <AdvisoryNpm
                                packageName={report.vulnerabilities[packageIdentifier].name}
                                advisory={
                                    {
                                        title: report.vulnerabilities[packageIdentifier].via[0].title,
                                        severity: report.vulnerabilities[packageIdentifier].severity,
                                        cve: "",
                                        cves: report.vulnerabilities[packageIdentifier].via[0].cwe,
                                        vulnerable_versions: "",
                                        url: report.vulnerabilities[packageIdentifier].via[0].url,
                                        affectedVersions: "",
                                        link: report.vulnerabilities[packageIdentifier].via[0].url
                                    }
                                }
                            />
                        </Tooltip>
                    </li>
                </ul>                
            </li>
        ))}
    </ul>;
}

export default AdvisoriesSummaryNpm;